var o = Object.defineProperty;
var C = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, L = Object.prototype.propertyIsEnumerable;
var c = (e, t, l) => t in e ? o(e, t, { enumerable: !0, configurable: !0, writable: !0, value: l }) : e[t] = l, h = (e, t) => {
  for (var l in t || (t = {}))
    i.call(t, l) && c(e, l, t[l]);
  if (C)
    for (var l of C(t))
      L.call(t, l) && c(e, l, t[l]);
  return e;
};
var m = (e, t) => {
  var l = {};
  for (var a in e)
    i.call(e, a) && t.indexOf(a) < 0 && (l[a] = e[a]);
  if (e != null && C)
    for (var a of C(e))
      t.indexOf(a) < 0 && L.call(e, a) && (l[a] = e[a]);
  return l;
};
import * as r from "react";
const p = (a) => {
  var n = a, {
    title: e,
    titleId: t
  } = n, l = m(n, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ r.createElement("svg", h({ width: 32, height: 32, viewBox: "0 0 22 22", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": t }, l), e ? /* @__PURE__ */ r.createElement("title", { id: t }, e) : null, /* @__PURE__ */ r.createElement("g", { clipPath: "url(#clip0_4050_63645)" }, /* @__PURE__ */ r.createElement("path", { d: "M19.5353 6.30503L15.6948 2.46534C15.5671 2.33763 15.4155 2.23632 15.2487 2.1672C15.0818 2.09808 14.903 2.0625 14.7224 2.0625C14.5418 2.0625 14.363 2.09808 14.1961 2.1672C14.0293 2.23632 13.8777 2.33763 13.75 2.46534L3.15305 13.0623C3.02482 13.1895 2.92315 13.341 2.85396 13.5078C2.78476 13.6747 2.74943 13.8536 2.75001 14.0342V17.8748C2.75001 18.2395 2.89487 18.5892 3.15274 18.8471C3.4106 19.1049 3.76033 19.2498 4.12501 19.2498H18.5625C18.7448 19.2498 18.9197 19.1774 19.0486 19.0484C19.1776 18.9195 19.25 18.7446 19.25 18.5623C19.25 18.38 19.1776 18.2051 19.0486 18.0762C18.9197 17.9472 18.7448 17.8748 18.5625 17.8748H9.91032L19.5353 8.24979C19.663 8.12211 19.7643 7.97052 19.8335 7.80367C19.9026 7.63683 19.9382 7.458 19.9382 7.27741C19.9382 7.09682 19.9026 6.91799 19.8335 6.75115C19.7643 6.5843 19.663 6.43271 19.5353 6.30503ZM7.96555 17.8748H4.12501V14.0342L11.6875 6.47175L15.5281 10.3123L7.96555 17.8748ZM16.5 9.34034L12.6603 5.49979L14.7228 3.43729L18.5625 7.27784L16.5 9.34034Z" })), /* @__PURE__ */ r.createElement("defs", null, /* @__PURE__ */ r.createElement("clipPath", null, /* @__PURE__ */ r.createElement("rect", { width: 22, height: 22 }))));
};
export {
  p as default
};
